import { search } from "../../searchDb";
import { clearSearchFilter, searchFiltered, selectNoteEntities } from "../notesSlice";

export function performSearchAsync(searchText) {
  return async (dispatch, getState) => {
    const notes = selectNoteEntities(getState());
    if(!searchText) {
      return dispatch(clearSearchFilter())
    }
    const filteredNoteIds = search(searchText).filter((id) => notes[id]);
    filteredNoteIds.sort((a, b) => {
      return notes[b].updated_at - notes[a].updated_at;
    });

    dispatch(searchFiltered({ searchText, filteredNoteIds }));
  };
}
